import React, { useState } from 'react'
import Headerone from '../headerone/newMain'
import Bredcom from '../Bredcom/Main'
import { Link } from 'react-router-dom'

function Prospectus() {
    return (
        <>
            <Headerone />
            <Bredcom title="Home" subtitle="Prospectus" />
            <section className="about-area about-p pt-120 pb-120 p-relative fix">
                <div className="animations-02">
                    <img src="/assets/img/bg/an-img-02.png" alt="contact-bg-an-01" />
                </div>
                <div className="container">
                    <div className="row justify-content-center align-items-center">                        
                        <div className="col-lg-12 col-md-12 col-sm-12">
                            <div className="about-content s-about-content pl-15 wow fadeInRight  animated" data-animation="fadeInRight" data-delay=".4s" >
                                <div className="about-title second-title pb-25">                                    
                                    <h3>Prospectus</h3>
                                </div>
                                <table className='table table-bordered'>
                                    <thead class="table-light head_red">
        <tr>
            <th scope="col">Sr. No.</th>
            <th scope="col">Name</th>
            <th scope="col">Link</th>
        </tr>
    </thead>
                                    <tbody>
                                        <tr>
                                            <td>1</td>
                                            <td>MVN Brochure</td>
                                            <td><a className='downloadlink' href="https://www.mvn.edu.in/documents/MVN-Brochure.pdf" target="_blank">Download</a></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Prospectus